import {Component} from '@angular/core';
import {distinctUntilChanged, Observable} from "rxjs";
import {Tour} from "../classes/tour.model";
import {TourService} from "../classes/tour.service";
import {TourTileComponent} from "../tour-tile/tour-tile.component";
import {CommonModule} from "@angular/common";
import {Analytics, logEvent} from "@angular/fire/analytics";
import {LanguageService} from "../classes/language.service";

@Component({
  selector: 'app-tour-overview',
  standalone: true,
  imports: [
    CommonModule,
    TourTileComponent,
  ],
  templateUrl: './tour-overview.component.html',
  styleUrl: './tour-overview.component.scss'
})
export class TourOverviewComponent {
  tours$: Promise<Tour[]> = this.tourService.loadTours();

  constructor(
    private tourService: TourService,
    private languageService: LanguageService,
    private analytics: Analytics,
  ) {
    this.tourService.activeTour$.next(null);

    this.tours$.then((tours: Tour[]) => {
      logEvent(this.analytics, 'view_item_list', {
        item_list_id: 'main_tour',
        item_list_name: 'Main Tour',
        item_list_category: 'Tours',
        "language": this.languageService.currentLang$.value,
        items: tours.map((tour: Tour) => {
          return {
            item_id: tour.id,
            item_name: tour.getTitle(),
            item_brand: 'AudioTour',
            item_category: 'Tour',
            item_variant: 'Tour',
            item_list_id: 'main_tour',
            item_list_name: 'Main Tour',
            index: tour.step,
            quantity: 1,
            price: 0,
            currency: 'EUR',
            "language": this.languageService.currentLang$.value
          };
        })
      });
    });
  }

  refreshTours() {
    this.tours$ = this.tourService.loadTours();
  }
}
